<template>
    <div id="pro-layout"
         class="open-form"
         :style="'background-color:' + backGroundColor">

        <form-container :code="code"
                        :loaded="loaded"
                        :logo="logo"
                        :no-header="true"
                        :txt-intro="txtIntro"
                        :cgu="cgu"
                        :organism="organism"
                        :referent="referent"
                        :sit="false">
        </form-container>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import hash from "object-hash"
import FormContainer from "./FormContainer.vue"
import PhoneNumber from "awesome-phonenumber"

export default {
    name: "OpenForm",
    components: { FormContainer },
    data() {
        return {
            loaded: false,
            code: null,
            providerId: null,
            communes: [],
            contacts: [],
            cguText: "Les Conditions d'utilisation ainsi que le Règlement sur le respect de la vie privée",
            referent: {},
            logo: {},
            cgu: null,
            organism: null,
            txtIntro: {},
            copyrightDialog: false,
            baseOpeningPeriods: null,
            basePricePeriods: null,
            draftInterval: null,
            webFormState: null,
            baseProviderHash: null,
            token: null,
            hasError: false,
            origin: null,
            comToParses: [],
            dayToParses: [],
            suggestedLocalisation: null,
        }
    },

    methods: {
        ...mapMutations("web_form", [
            "resetState",
            "setProvider",
            "setFields",
            "setFamilyElements",
            "setContact",
            "setSubmitted",
            "setCapacities",
            "setRoomRenting",
            "setCategoryFamilies",
            "setExtra",
            "setSuggestedH24",
            "setIsDirty",
            "setAiEnabled",
            "setId",
            "generateTabulations",
            "handleSpecificTabulation",
            "orderTabulations",
            "generateTabActiveRanges",
            "setDisplayThanks",
            "setOrigin",
            "setIsOpenForm",
            "setInitProvider",
            "setBasePricePeriods",
            "setBaseOpeningPeriods",
            "setBooleanFieldValues",
            "setDateFieldValues",
            "setCurrency",
            "formatPricePeriods",
            "formatContents",
            "formatCommunications",
            "formatPricePeriods",
            "pushSuggestedCommunications",
            "setSuggestedAddress",
            "setSuggestedCommune",
            "pushSuggestedMedias",
            "setSuggestedOpeningDays",
            "setSuggestedMedias",
            "setSourcesLoaded",
            "setEditedTabulations",
            "setPreview",
            "setAllSuggestedMediasLoaded",
            'setAccountTisType',
            'setNumericFieldValues',
        ]),
        ...mapMutations("webFormStyle", [
            "setFieldsColor",
            "setTitlesColor",
            "setPrimaryColor",
            "setBackGroundColor",
            "setFontFamily",
            "resetState",
        ]),
        ...mapMutations("forbiddenCriteria", ["setForbiddenCriteria"]),
        setBasePeriods(initProvider) {
            setTimeout(() => {
                this.setInitProvider(initProvider)
                this.setBasePricePeriods()
                this.setBaseOpeningPeriods()
            }, 2000)
        },
        getProvider() {
            this.setIsDirty(false)

            this.baseProviderHash = null

            let payload = {
                provider_id: this.providerId,
            }

            return this.$http.post("providers/open-form", payload).then((res) => {
                if (res.body.code !== null && res.body.code !== undefined) {
                    this.hasError = true
                    this.code = res.body.code
                }

                if (res.body.success) {
                    let families = res.body.data.categoryFamilies
                    this.cgu = res.body.data.cgu
                    this.organism = res.body.data.organism

                    let provider = res.body.data.provider
                    let initProvider = res.body.data.initProvider
                    let answer = res.body.data.answer

                    if (initProvider === null) {
                        initProvider = provider
                    }

                    if (answer !== null && answer !== undefined && answer.web_form !== null) {
                        this.token = answer.web_form.token
                    }

                    this.setProvider(provider)
                    this.setFields(res.body.data.fields)
                    this.formatContents(this.languages)
                    this.formatCommunications(this.communicationTypes)
                    this.setFamilyElements(res.body.data.referential)
                    this.setContact(res.body.data.contact)
                    this.setRoomRenting(res.body.data.provider.room_renting)
                    this.setCategoryFamilies(families)
                    this.setAiEnabled(res.body.data.aiEnabled)
                    this.setForbiddenCriteria(res.body.data.forbiddenCriteria)
                    this.setCurrency(res.body.data.currency)
                    this.setBooleanFieldValues()
                    this.setDateFieldValues()
                    this.formatPricePeriods()
                    this.setEditedTabulations(res.body.data.editedTabulations)
                    this.setAccountTisType(res.body.data.accountTisType)
                    this.setNumericFieldValues()

                    if (answer !== null) {
                        let contact = {
                            first_name: answer.first_name,
                            last_name: answer.last_name,
                            email: answer.email,
                            id: res.body.data.contact.id,
                            token: res.body.data.contact.token,
                        }

                        this.setExtra(answer.extra)
                        this.setContact(contact)
                    }

                    let capacities = this.getFamilyByCode("Capacites")
                    this.setCapacities(capacities)
                    this.setBasePeriods(initProvider)

                    let config = res.body.data.configurations

                    this.logo = config.logo

                    if (this.$route.query.preview === undefined) {
                        this.txtIntro = res.body.data.txtIntro !== null ? res.body.data.txtIntro : config.txtIntro
                    } else if (this.$route.query.casp !== undefined) {
                        this.txtIntro = this.txtIntroCasp
                    } else {
                        this.txtIntro = this.txtIntroCmaj
                    }

                    this.referent = res.body.data.referent
                    this.loaded = true

                    this.generateTabulations(false)
                    this.handleSpecificTabulation()
                    this.orderTabulations()

                    setTimeout(() => {
                        this.generateTabActiveRanges()
                    }, 1000)

                    setTimeout(() => {
                        if (this.$route.query.origin !== "USKA") {
                            this.loadCustomCss(res.body.data.webFormStyle)
                        } else {
                            this.resetState()
                        }
                    }, 500)

                } else {
                    this.loaded = true
                }
            })
        },
        loadCustomCss(attributes) {
            if (attributes !== null && this.$route.query.preview === undefined) {
                this.setFontFamily(attributes.font_family)
                this.setPrimaryColor(attributes.primary_color)
                this.setTitlesColor(attributes.title_color)
                this.setBackGroundColor(attributes.background_color)
                this.setFieldsColor(attributes.field_color)
            } else if (this.$route.query.preview !== undefined && this.$route.query.casp !== undefined) {
                this.setFontFamily(this.caspFontFamily)
                this.setPrimaryColor(this.caspPrimaryColor)
                this.setTitlesColor(this.caspTitlesColor)
                this.setBackGroundColor(this.caspBackGroundColor)
                this.setFieldsColor(this.caspFieldsColor)
            }
        },
        fetchExternalMedias(source) {
            let payload = {
                source: source,
                token: this.token,
                providerId: this.providerId,
                mediaLimit: 3,
            }

            return this.$http.post("online-presence/medias", payload).then(res => {
                let medias = res.body.data.medias
                let communications = res.body.data.communications
                let localisation = res.body.data.localisation
                let openingDays = res.body.data.openingDays ?? []
                let h24 = res.body.data.h24

                if (h24) {
                    this.setSuggestedH24(h24)
                }

                if (medias.length < 3 && source === "GOOGLE") {
                    this.setAllSuggestedMediasLoaded(true)
                }

                medias = medias.map(media => {
                    if (media.thumbnail_url === null) {
                        media.thumbnail_url = media.origin_url
                    }

                    return media
                })

                this.comToParses = [...this.comToParses, ...communications]
                this.dayToParses = [...this.dayToParses, ...openingDays]

                this.pushSuggestedMedias(medias)

                if (localisation !== null) {
                    this.suggestedLocalisation = localisation
                }
            })
        },
        parseSuggestedCommunications() {
            if (this.comToParses && this.suggestedCommunications) {
                this.comToParses.forEach(com => {
                    let hasSuggestion = this.suggestedCommunications.find(suggestedCom => suggestedCom.type.name === com.type.name)

                    if (hasSuggestion === undefined && this.provider !== null) {
                        let hasSameValue = false

                        this.provider.communications.forEach(providerCom => {
                            if (providerCom.type.name === com.type.name && !hasSameValue) {
                                if (providerCom.type.name === "PHONE" || providerCom.type.name === "FAX") {
                                    let phone1 = com.value !== null ?
                                      new PhoneNumber(com.value, "FR").getNumber() : null
                                    let phone2 = providerCom.value !== null ?
                                      new PhoneNumber(providerCom.value, "FR").getNumber() : null

                                    hasSameValue = phone1 === phone2
                                } else if (["WEBSITE", "TRIPADVISOR", "YELP", "FACEBOOK", "GOOGLE", "YOUTUBE", "INSTAGRAM", "LINKEDIN", "TIKTOK"]
                                  .includes(providerCom.type.name)) {
                                    let url1 = com.value ?? ""

                                    url1 = url1.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                    let url2 = providerCom.value ?? ""
                                    url2 = url2.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                    if (url1.charAt(url1.length - 1) === "/") {
                                        url1 = url1.substr(0, url1.length - 1)
                                    }

                                    if (url2.charAt(url2.length - 1) === "/") {
                                        url2 = url2.substr(0, url2.length - 1)
                                    }

                                    if (com.type.name === "GOOGLE") {
                                        let index1 = url1.indexOf("&")
                                        if (index1 >= 0) {
                                            url1 = url1.slice(0, index1)
                                        }

                                        let index2 = url2.indexOf("&")
                                        if (index2 >= 0) {
                                            url2 = url2.slice(0, index2)
                                        }
                                    } else if (["FACEBOOK", "INSTAGRAM"].includes(com.type.name)) {
                                        let index1 = url1.indexOf("?")
                                        if (index1 >= 0) {
                                            url1 = url1.slice(0, index1 - 1)
                                        }

                                        let index2 = url2.indexOf("?")
                                        if (index2 >= 0) {
                                            url2 = url2.slice(0, index2 - 1)
                                        }
                                    }

                                    hasSameValue = url1 === url2
                                } else if (providerCom.value === com.value) {
                                    hasSameValue = true
                                }
                            }
                        })

                        if (!hasSameValue) {
                            this.pushSuggestedCommunications([com])
                        }
                    }
                })
            }
        },
        parseSuggestedLocalisation() {
            if (this.provider !== undefined && this.provider !== null) {
                let lowerAddr = this.provider.localisation.address !== null ? this.provider.localisation.address.toLocaleLowerCase() : null

                if (this.suggestedLocalisation !== null &&
                  this.suggestedLocalisation.address !== null &&
                  this.suggestedLocalisation.address.toLocaleLowerCase() !== lowerAddr) {

                    let lowerSuggestAddr = this.suggestedLocalisation.address.toLocaleLowerCase()
                    lowerSuggestAddr = lowerSuggestAddr.replace(",", "")
                    lowerAddr = lowerAddr.replace(",", "")

                    if (lowerSuggestAddr !== lowerAddr) {
                        this.setSuggestedAddress(this.suggestedLocalisation.address)
                    }
                }

                if (this.suggestedLocalisation !== null &&
                  this.suggestedLocalisation.commune !== null &&
                  this.suggestedLocalisation.commune.id !== this.provider.localisation.commune.id) {

                    this.setSuggestedCommune(this.suggestedLocalisation.commune)
                }
            }
        },
        parseSuggestedOpeningDays() {
            if (this.provider !== null) {
                if (this.provider.opening_periods.length === 0) {
                    this.setSuggestedOpeningDays(this.dayToParses)
                } else {
                    let period = this.provider.opening_periods[0]
                    let hasDiffs = false

                    if (this.dayToParses) {
                        this.dayToParses.forEach(dayToParse => {
                            const day = period.opening_days.find(openingDay => openingDay.day_of_week === dayToParse.day_of_week)

                            if (dayToParse.opening_hours.length === 0) {
                                dayToParse.opening_hours.push({ open: null, close: null })
                            }

                            if (day !== null && day !== undefined) {
                                hasDiffs = (day.closed !== dayToParse.closed ||
                                  hash(this.cleanEmptyHours(day.opening_hours)) !==
                                  hash(this.cleanEmptyHours(dayToParse.opening_hours))) || hasDiffs
                            }
                        })
                    }

                    if (hasDiffs) {
                        this.dayToParses.forEach(dayToParse => {
                            this.setSuggestedOpeningDays([dayToParse])
                        })
                    }
                }
            }
        },
        cleanEmptyHours(hours) {
            let clearedHours = hours !== undefined ? JSON.parse(JSON.stringify(hours)) : []

            clearedHours.forEach((hour, index) => {
                if (hour.open === null && hour.close === null) {
                    clearedHours.splice(index, 1)
                }
            })

            return clearedHours
        },
        sortSuggestedMedias() {
            let sorted = this.suggestedMedias.sort((media1, media2) => {
                return media2.quality - media1.quality
            })

            this.setSuggestedMedias(sorted.slice(0, 10))
        },
    },

    computed: {
        ...mapState("web_form", [
            "provider",
            "contact",
            "extra",
            "submitted",
            "capacities",
            "roomRenting",
            "categoryFamilies",
            "isDirty",
            "suggestedMedias",
            "suggestedCommunications",
        ]),
        ...mapState("resource", ["communicationTypes", "languages"]),
        ...mapState("account", ["user"]),
        ...mapState("webFormStyle", ["fontFamily", "primaryColor", "titlesColor", "fieldsColor", "backGroundColor",
            "caspFontFamily", "caspPrimaryColor", "caspTitlesColor", "caspFieldsColor", "caspBackGroundColor",
            "txtIntroCmaj", "txtIntroCasp"]),
        ...mapGetters("web_form", ["hasField", "hasFamilyElement", "getFamilyByCode", "getElementsByFamilyCode"]),
    },

    watch: {
        webFormState() {
            if (this.draftInterval !== null && this.webFormState === "DRAFT") {
                clearInterval(this.draftInterval)
            }
        },
    },

    async created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        if (this.$route.query.preview === undefined) {
            this.resetState()
        }

        this.setOrigin(this.$route.query.origin)
        this.setIsOpenForm(true)

        this.providerId = this.$route.params.providerId

        this.setId(this.providerId)

        this.$store.dispatch("resource/fetchLanguages")
        this.$store.dispatch("resource/fetchProfessions")
        this.$store.dispatch("resource/fetchCurrencies")
        await this.$store.dispatch("resource/fetchCommunicationTypes")

        const promise1 = this.getProvider()
        const promise2 = this.fetchExternalMedias("GOOGLE")
        const promise3 = this.fetchExternalMedias("GOOGLE_CUSTOM")

        Promise.all([promise1, promise2, promise3]).then(() => {
            // this.sortSuggestedMedias()
            this.setSourcesLoaded(true)
            this.parseSuggestedCommunications()
            this.parseSuggestedLocalisation()
            this.parseSuggestedOpeningDays()
        })

        if (this.$route.query.preview !== undefined) {
            this.setPreview(true)
        }
    },

    beforeDestroy() {
        window.onbeforeunload = null
    },
}
</script>